/* eslint-disable import/prefer-default-export */
/* eslint-disable no-prototype-builtins */

import { useMemo } from 'react';

export const useMemoizedSims = box => {
  const sims = useMemo(() => {
    if (!box.hasOwnProperty('modems')) return { keys: ['', ''] };
    const { modems } = box;
    if (!modems.length || !modems[0].sims) return { keys: ['', ''] };
    return {
      keys: modems[0].sims,
    };
  }, [box]);

  return [sims];
};
